import api from "../../../Component/axios";

export const useVariedades = () => {
  const token = localStorage.getItem("@Token");
  const getVariedades = async () => {
    try {
      const response = await api.get(
        "api/cultivo/response/all-tipo-cultivo/variedad",
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Token " + token,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  return { getVariedades };
};
